import { render } from "./AboutClients.vue?vue&type=template&id=d6abf792"
import script from "./AboutClients.vue?vue&type=script&lang=js"
export * from "./AboutClients.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__